import { render, staticRenderFns } from "./Table5.vue?vue&type=template&id=c42a70cc&scoped=true&"
import script from "./Table5.vue?vue&type=script&lang=js&"
export * from "./Table5.vue?vue&type=script&lang=js&"
import style0 from "./Table5.vue?vue&type=style&index=0&id=c42a70cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42a70cc",
  null
  
)

export default component.exports